import api from '@/api'
import endpoints from '@/api/endpoints'

const NebApi = Object.create({
  install: function (Vue) {
    Vue.prototype.$http = api
    Vue.prototype.$endpoints = endpoints
  }
})

export default NebApi
